import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/nodebook.png";
import video from "../assets/vid/nodebook-video.mp4";
import Video from 'src/components/Video';


export const projectDetails: ProjectInterface = {
    url: "nodebook",
    title: "Nodebook",
    summary: "Simple clone of Milanote made with Unity.",
    description: `I wanted an app for saving notes, project management and organization in general. Milanote was the better app I’ve found but given the price I decided to create an open-source alternative of it, but later I’ve found that I could have everything I needed by using the Obsidian app so I just used this project as a way to study saving strategies and managing UI.`,
    year: "2024",
    tags: ["All-in-one Workspace", "Study Project", "Unity"],
    imageSrc: cover,
    hasVideo: true,
    startVideoTime: 0,
    videoSrc: video,
    isCoverType: false,
    haveTags: true,
    projectType: ProjectType.SIDE,
    roles: ["Programmer"],
    technologies: ["Unity", "C#"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "Overthrowing Milanote… or not",
    linkData: [
        { type: 'github', url: "https://github.com/lucasctnh/nodebook" },
        { type: 'text', url: "https://github.com/lucasctnh/nodebook" },
    ],
    relatedProjects: ["ProceduralStudy", "CheckMore"],
};


export function Nodebook() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                leftContent={
                    <div className="a-left-no-bg">
                        <Video src={video} />
                    </div>
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}